var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileXls(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.705,
    rx: 4,
    transform: "translate(.063 .148)",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.815 25 5.795-9.025L8.302 7h4.272l2.897 5.737c.267.543.45.95.55 1.217h.037c.193-.435.392-.857.6-1.268L19.755 7h3.922l-5.445 8.925L23.815 25h-4.172l-3.348-6.302a5.255 5.255 0 0 1-.4-.84h-.049c-.058.2-.187.473-.387.816L12.012 25H7.815z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileXls);
export default __webpack_public_path__ + "static/media/file-xls.111b36ed.svg";
export { ForwardRef as ReactComponent };